import React, {
  useCallback,
  useContext, useEffect, useMemo, useState,
} from 'react';
import PropTypes, { node } from 'prop-types';
import { injectIntl, intlShape } from '@edx/frontend-platform/i18n';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router';

import Footer from '@npoed/frontend-component-footer';
import {
  ActionRow, Button, FormGroup, ModalDialog, TextArea, Toast, useToggle,
} from '@edx/paragon';
import { LearningHeader as Header } from '@npoed/frontend-component-header';
import ModalDialogHeader from '@edx/paragon/src/Modal/ModalDialogHeader';
import ModalDialogTitle from '@edx/paragon/src/Modal/ModalDialogTitle';
import ModalDialogBody from '@edx/paragon/src/Modal/ModalDialogBody';
import { StarRating } from '@npoed/frontend-theme';
import ModalDialogFooter from '@edx/paragon/src/Modal/ModalDialogFooter';
import { AppContext } from '@edx/frontend-platform/react';
import { auth } from '@edx/frontend-platform';
import { boolean } from '@pact-foundation/pact/src/dsl/matchers';
import PageLoading from '../generic/PageLoading';
import { getAccessDeniedRedirectUrl } from '../shared/access';
import { useModel } from '../generic/model-store';

import genericMessages from '../generic/messages';
import messages from './messages';
import LoadedTabPage from './LoadedTabPage';
import { setCallToActionToast } from '../course-home/data/slice';
import { fetchDialog, fetchReview } from './data/thunks';
import { fetchDialogSuccess } from './data/slice';

const maxReviewMark = 10;
function TabPage({ intl, ...props }) {
  const {
    activeTabSlug,
    courseId,
    courseStatus,
    metadataModel,
    unitId,
  } = props;
  const {
    toastBodyLink,
    toastBodyText,
    toastHeader,
  } = useSelector(state => state.courseHome);
  const { shouldShowDialog, reviewStatus } = useSelector(state => state.tabPage);
  console.log('Code:', shouldShowDialog);
  const dispatch = useDispatch();
  const {
    courseAccess,
    number,
    org,
    start,
    title,
  } = useModel(metadataModel, courseId);

  const { authenticatedUser } = useContext(AppContext);
  const [isOpen, open, close] = useToggle(false);
  const [reviewText, setReviewText] = useState('');
  const [reviewMark, setReviewMark] = useState(0);

  useEffect(() => {
    if (courseId && authenticatedUser) {
      dispatch(fetchDialog(courseId, authenticatedUser.username));
    }
  }, [courseId, authenticatedUser]);

  useEffect(() => {
    if (shouldShowDialog) {
      open();
      dispatch(fetchDialogSuccess({ shouldShowDialog: false }));
    }
    console.log('Effect took place:', shouldShowDialog);
  }, [shouldShowDialog]);

  const sendReview = () => {
    dispatch(fetchReview(courseId, reviewMark, reviewText, authenticatedUser.username));
    close();
    console.log('Review status:', reviewStatus);
  };

  if (courseStatus === 'loading') {
    return (
      <>
        <Header />
        <PageLoading
          srMessage={intl.formatMessage(messages.loading)}
        />
        <Footer />
      </>
    );
  }

  if (courseStatus === 'denied') {
    const redirectUrl = getAccessDeniedRedirectUrl(courseId, activeTabSlug, courseAccess, start, unitId);
    if (redirectUrl) {
      return (<Redirect to={redirectUrl} />);
    }
  }

  // Either a success state or a denied state that wasn't redirected above (some tabs handle denied states themselves,
  // like the outline tab handling unenrolled learners)
  if (courseStatus === 'loaded' || courseStatus === 'denied') {
    return (
      <>
        <Toast
          action={toastBodyText ? {
            label: toastBodyText,
            href: toastBodyLink,
          } : null}
          closeLabel={intl.formatMessage(genericMessages.close)}
          onClose={() => dispatch(setCallToActionToast({ header: '', link: null, link_text: null }))}
          show={!!(toastHeader)}
        >
          {toastHeader}
        </Toast>
        <Header
          courseOrg={org}
          courseNumber={number}
          courseTitle={title}
        />
        {/* <Button variant="outline-primary" onClick={open}>Оставить отзыв</Button> */}
        <ModalDialog isFullscreenScroll size="lg" title="Test review Dialog" isOpen={isOpen} onClose={close} hasCloseButton>
          <ModalDialogHeader>
            <ModalDialogTitle>
              Это тестовое диалоговое окно для отзыва
            </ModalDialogTitle>
          </ModalDialogHeader>
          <ModalDialogBody>
            <FormGroup>
              <StarRating count={maxReviewMark} value={reviewMark} onChange={value => setReviewMark(value)} />
            </FormGroup>
            <FormGroup>
              <TextArea label="Оставьте отзыв, пожалуйста:" value={reviewText} onChange={value => setReviewText(value)} style={{ resize: 'none' }} />
            </FormGroup>
          </ModalDialogBody>
          <ModalDialogFooter>
            <ActionRow>
              <Button variant="primary" onClick={sendReview}>Оставить отзыв</Button>
            </ActionRow>
          </ModalDialogFooter>
        </ModalDialog>
        <LoadedTabPage {...props} />
        <Footer />
      </>
    );
  }

  // courseStatus 'failed' and any other unexpected course status.
  return (
    <>
      <Header />
      <p className="text-center py-5 mx-auto" style={{ maxWidth: '30em' }}>
        {intl.formatMessage(messages.failure)}
      </p>
      <Footer />
    </>
  );
}

TabPage.defaultProps = {
  courseId: null,
  unitId: null,
};

TabPage.propTypes = {
  activeTabSlug: PropTypes.string.isRequired,
  intl: intlShape.isRequired,
  courseId: PropTypes.string,
  courseStatus: PropTypes.string.isRequired,
  metadataModel: PropTypes.string.isRequired,
  unitId: PropTypes.string,
};

export default injectIntl(TabPage);
